import { addLabelArray } from "helpers/addLabelArray";
import { tanksCases } from "./types";

const {
    TANKS_INPUTS,
    GET_TANKS,
    CREATE_TANK,
    EDIT_TANK,
    DELETE_TANK,
} = tanksCases

const initialState = {
    company: null,
    station: [],
    tanks: [],
    tanksFiltered: [],
    tankAllocation: []
}

export const tanksReducer2 = (state = initialState, { type, payload }) => {
    switch (type) {

        case TANKS_INPUTS:
            if (payload.key === 'company') {
                return {
                    ...state,
                    [payload.key]: payload.value,
                    station: [],
                }
            }

            return {
                ...state,
                [payload.key]: payload.value
            }

        case GET_TANKS:
            return {
                ...state,
                tanks: payload
            }

        case CREATE_TANK:
            return {
                ...state,
                tanks: [payload, ...state.tanks]
            }

        case EDIT_TANK:
            let tankState = [...state.tanks]
            const idx = tankState.findIndex((tank) => tank.id === payload.id)
            if (idx !== -1) {
                tankState[idx] = {
                    ...tankState[idx],
                    ...payload
                }
                return {
                    ...state,
                    tanks: tankState
                }
            }
            return state

        case DELETE_TANK:
            const tanksFiltered = state.tanks.filter((tank) => tank.id !== payload)
            return {
                ...state,
                tanks: tanksFiltered
            }
        default:
            return state
    }
}